import React from 'react'
import { LinkButton } from '../../common/menu/linkButton'
import { TitleHighlight } from '../../ui/typo/TitleHighlight'
import { HomeHeading } from './Heading'

export const LamadashSection = () => {
  const features = [
    {
      title: 'Page employeur',
      description:
        'Votre meilleure alliée pour convaincre les candidats de postuler !',
      icon: (
        <img
          className="w-40 h-40"
          src="/page-employeur.webp"
          alt="Créer votre page employeur"
        />
      ),
    },
    {
      title: "Offres d'emploi",
      description:
        'Captez des candidatures qualifiées en diffusant vos opportunités sur un site spécialisé.',
      icon: (
        <img
          className="w-40 h-40"
          src="/offres-emploi.webp"
          alt="Notification des offres d'emploi"
        />
      ),
    },
    {
      title: 'Gestion des recrutements',
      description:
        'Collaborez sur le suivi de vos recrutements et répondez en un clic aux candidatures.',
      icon: (
        <img
          className="w-40 h-40"
          src="/gestion-recrutements.webp"
          alt="Créer votre page employeur"
        />
      ),
    },
    {
      title: 'Lamatch',
      description:
        'Nous matchons automatiquement les candidats qui correspondent à vos besoins.',
      icon: (
        <img
          className="w-40 h-40"
          src="/lamatch<3.webp"
          alt="icon de l'application Lamatch"
        />
      ),
      isNew: true,
    },
  ]

  return (
    <section className="px-4 py-12 space-y-8 md:py-14 lg:py-20 xl:py-24 md:space-y-10 lg:space-y-12 xl:space-y-14">
      <div className="container flex flex-col items-center max-w-3xl mx-auto space-y-2 md:space-y-4 lg:space-y-6 xl:space-y-8">
        <HomeHeading additionalClasses="text-center">
          La <TitleHighlight>plateforme</TitleHighlight> qui vous rapproche de
          vos candidats
        </HomeHeading>

        <p className="text-lg font-medium text-center text-night">
          Nous facilitons la connexion entre candidats et cabinets, en créant
          des solutions dédiées à la profession, pour vous permettre de recruter
          les candidats qui correspondent à vos besoins.
        </p>
      </div>
      <ul className="container mx-auto space-y-6 md:space-y-0 md:flex md:space-x-12 lg:space-x-14 xl:space-x-16">
        {features.map(({ title, description, icon }) => (
          <li
            className="relative flex flex-col items-center justify-center text-center"
            key={title}
          >
            {icon}
            <p className="my-4 text-2xl font-semibold text-primary">{title}</p>
            <p className="font-thin text-night">{description}</p>
          </li>
        ))}
      </ul>
      <div className="flex justify-center">
        <LinkButton
          label="Je crée ma page employeur"
          href="/je-suis-un-cabinet"
          isInverted
        />
      </div>
    </section>
  )
}
